export { getClientSentryEventContext } from '@/shared/utils/sentry/clientIgnoreRules/getClientSentryEventContext';
export { shouldIgnoreClientSentryEvent } from '@/shared/utils/sentry/clientIgnoreRules/shouldIgnoreClientSentryEvent';
